module.exports = __webpack_public_path__ + "img/quailMain.ce43fe0f.jpg";